import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import {cleanTextInput} from '../../utils/helpers';

import ImageContainer from '../image-handler/ImageContainer';
import FormInput from '../forms/FormInput';

import FaQuestionCircle from 'react-icons/lib/fa/question-circle';

class Step4 extends Component {

    componentDidMount() {
        window.$('select').material_select();
    }

    renderSelect(type) {
        let name,
            options,
            value;
        let disabled = false;
        switch(type) {

            case 'L1':
                name = 'BATHTUB.L1';
                options = this.props.bathtub.L1.Values.Value;
                value = this.props.bathtub.L1.CurrentValue;
            break;
            case 'L2':
                name = 'BATHTUB.L2';
                options = this.props.bathtub.L2.Values.Value;
                value = this.props.bathtub.L2.CurrentValue
                break;
            case 'AT':
                name = 'BATHTUB.ATP';
                options = this.props.bathtub.ATP.Values.Value;
                value = this.props.bathtub.ATP.CurrentValue;
            break;
            default:
                name = 'BATHTUB.AT';
                options = this.props.bathtub.default_options;
                value = this.props.bathtub.AT.CurrentValue;
                disabled = true;

        }
        return (
            <FormInput
                type='select'
                name={name}
                options={options}
                value={value}
                disabled={disabled}
                label={this.props.translate('BATHTUB.stepFour.form.position')}
                divClass='col s6 m3'
            />
        );
    }

    render() {
        return (
            <div className="wt-step-4 step-content">
                <div className='row'>
                    <h5 className='col s6' >
                        {this.props.translate('BATHTUB.stepFour.menu.title')}
                    </h5>
                </div>
                <div className="row" style={{paddingBottom: "60px"}}>
                    <div className="col s12 m6">
                        <FormInput
                            type="select"
                            options={this.props.bathtub.MISSING_options}
                            name="BATHTUB.lochbohrungen_select"
                            value={this.props.bathtub.lochbohrungen_select.CurrentValue}
                            checked={this.props.bathtub.lochbohrungen_select.CurrentValue}
                            divClass="col s12" />
                    </div>
                    {this.renderSelect(this.props.bathtub.lochbohrungen_select.CurrentValue)}
                    <FormInput
                        type='number'
                        labelPosition='inline'
                        subLabelStyle={{paddingLeft: '5px'}}
                        subLabel='mm'
                        fieldStyle={{marginLeft: '10px', width: '50%'}}
                        name='BATHTUB.L2M'
                        value={this.props.bathtub.L2M.CurrentValue}
                        disabled={!['23', '45', '67', '81', '99'].includes(this.props.bathtub.L2.CurrentValue)}
                        divClass='col s6 m2' />
                    <div className='col m1 right-align'>
                        <FaQuestionCircle className='right-align' style={{fontSize: '20px'}} />
                    </div>
                </div>
                <div className='row' style={{paddingBottom: "60px"}}>
                    <ImageContainer
                        image={this.props.image.Image}
                        name='bathtub'
                        divClass='col m6 offset-m3'
                        height='100%' />
                </div>
                {this.props.bathtub.lochbohrungen_select.CurrentValue === 'AT' ?
                    <div className='row'>
                        <div className='col s12 m4'>
                            <FormInput
                                    type='select'
                                    label={this.props.translate('BATHTUB.stepFour.form.armatur')}
                                    name='BATHTUB.AT'
                                    options={this.props.bathtub.AT.Values.Value}
                                    value={this.props.bathtub.AT.CurrentValue}
                                    divClass='col s12' />
                        </div>
                        <FormInput
                            type='text'
                            label={this.props.translate('BATHTUB.stepFour.form.anmerkung')}
                            name='BATHTUB.ARS_T'
                            value={this.props.bathtub.AT.CurrentValue === '9999' ? cleanTextInput(this.props.bathtub.ARS_T.CurrentValue) : ''}
                            disabled={this.props.bathtub.AT.CurrentValue !== '9999'}
                            placeholder={this.props.translate('BATHTUB.stepFour.form.anmerkung_placeholder')}
                            fieldStyle={{width: '100%', padding: 0}}
                            divClass='col s12 m4' />
                        <div className='col s12'>
                            <div className='col s4 m4'>
                                <p className='radio-desc'>
                                    &#42; ({this.props.translate('BATHTUB.stepFour.form.drawing_necessary')})
                                </p>
                            </div>
                            <div className='col s8 m4'>
                                <form action='#'>
                                    <div className='file-field' style={{paddingTop: '6px'}}>
                                        <div className='btn btn-flat' style={{padding: 0}}>
                                            <span>{this.props.translate('BATHTUB.stepFour.form.drawing_upload')}</span><i className='material-icons'>arrow_forward</i>
                                            <input type='file'/>
                                        </div>
                                        <div className='file-path-wrapper'>
                                            <input className='file-path validate' type='text'/>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                : ""}
            </div>
        )
    }

}

/**
 * Prop types
 * @type {{tempDetails: *}}
 */
Step4.propTypes = {
    stepControl: PropTypes.func.isRequired,
    bathtub:     PropTypes.object.isRequired,
};

function mapStateToProps({bathtub, locale, image}) {
    return {
        bathtub,
        translate: getTranslate(locale),
        image,
    }
}

export default connect(mapStateToProps, actions)(Step4);



// WEBPACK FOOTER //
// ./src/components/bathtub-steps/Step4.js